import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import { TAAConstants } from "../../constants/taa-constants";
import { AppService } from "../../services/app.service";
import { LoggerService } from "../../services/audit-logger.service";
import { CommonService } from "../../services/common.service";
import { PersonService } from "../../services/person.service";
import { RequestSubmitService } from "../../services/requestsubmit.service";
import { TestService } from "../../services/test.service";
import { User } from "../../services/user.model";
import { StepperComponent } from "../stepper/stepper.component";

@Component({
  selector: "app-testinginformation",
  templateUrl: "./testinginformation.component.html",
  styleUrls: ["./testinginformation.component.css"]
})
export class TestinginformationComponent implements OnInit, OnDestroy {
  public taaPin: string;
  public successMessage: boolean;
  public errorMsg: boolean = false;
  public showTest: boolean = false;
  public showTestDate: boolean = false;
  public noOfErrors: number;
  public userProfile: User;
  frmTestingInfo: FormGroup;
  formSubmitted = false;
  Name: string;
  public testOptions: any = [];
  public savedTestCenter: any;
  public savedTestDate: any;
  public recordExits: any = 0;
  public copySavedTestDate: any;
  public testDates: any = [];
  public displayDates: boolean = false;
  public testFlag: boolean = false;
  public testDateFlag: boolean = false;
  public dynamicText: any;
  public currentRecord: any;
  public personTestId: any;
  public testDateId: any;
  public testDateType: any;
  public testId: any;
  public personId: any;
  public requestId: any;
  public personName: string;
  private subscriptions: Array<Subscription> = [];
  public isLoading: boolean = false;
  public isLoadingDates: boolean = false;
  public countRecords: number = 0;
  public oldDates: any = [];
  public oldTestList: any;
  public orgDetails: object = {};
  public stateTestId: string;
  recordCount = "0";
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public statusCd: string;
  public clickOnce: boolean;
  public reconsideration: string;
  constructor(
    public stepper: StepperComponent,
    public appService: AppService,
    public testService: TestService,
    private personService: PersonService,
    public commonService: CommonService,
    public fb: FormBuilder,
    public taaConstants: TAAConstants,
    private _loggerService: LoggerService,
    public requestSubmitService: RequestSubmitService
  ) { }

  ngOnInit() {
    this.clickOnce = false;
    sessionStorage.setItem("examineeSubmitted", "");
    this.testDates = [];
    if (sessionStorage.getItem("currentStudent")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("currentStudent")
      );
      this.stepper.onRequestSave(studentDetails, false);
      this.currentRecord = studentDetails;
    }
    if (sessionStorage.getItem("selectedOrg")) {
      this.orgDetails = JSON.parse(sessionStorage.getItem("selectedOrg"));
    }
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    if (this.currentRecord) {
      this.isLoadingDates = true;
      this.testService.getPersonCount(this.currentRecord).subscribe(res => {
        this.recordExits = res.body;
      });
      Observable.forkJoin(
        this.testService.getRequest(this.currentRecord),
        this.testService.getTest()
      ).subscribe(([res, tests]) => {
        if (res && tests) {
          const testsDetails: any = tests;
          testsDetails.forEach(element => {
            if (element.TEST_NM === "ACT State and District Testing") {
              this.stateTestId = element.TEST_ID;
            }
          });
          let getTestDates: any;
          const result: any = res.body;
          const testCenter = result[0].TEST_ID;
          this.savedTestDate = result[0].TEST_DATE_ID;
          if (this.stateTestId === testCenter) {
            getTestDates = this.testService.getStateTestDatesById(
              this.stateTestId,
              this.orgDetails["mdmId"]
            );
          } else {
            getTestDates = this.testService.getDates(testCenter);
          }
          if (testCenter !== null && this.savedTestDate !== null) {
            this.testDateId = this.savedTestDate;
            this.displayDates = true;
            Observable.forkJoin([
              getTestDates,
              this.commonService.getFinishedRecordCount(
                this.currentRecord.personId
              )
            ])
              .finally(() => {
                this.isLoadingDates = false;
              })
              .subscribe(([response, finishedRecordCount]) => {
                const data: any = response[0]
                  ? response[0].body
                  : (response as any).body;
                const today = new Date();
                if (Array.isArray(data)) {
                  for (let i = 0; i < data.length; i++) {
                    const endDate = new Date(data[i].REQUEST_CUT_OFF_DT);
                    if (endDate > today) {
                      data[i].disable = false;
                      this.testDates.push(data[i]);
                    } else {
                      data[i].disable = true;
                      data[i].dynamicText = this.dynamicText;
                      this.testDates.push(data[i]);
                    }
                  }
                }
                this.recordCount = finishedRecordCount as any;
              });
            this.savedTestCenter = testCenter;
            this.copySavedTestDate = this.savedTestDate;
            this.testDateFlag = true;
            this.testFlag = true;
          } else {
            this.testFlag = false;
            this.testDateFlag = false;
          }
        }
      });
    }
    const text = "KEY_MSG_CUTOFF_DATE_EXPIRED";
    this.commonService.getDynamicContent(text).subscribe(response => {
      this.dynamicText = response[0].DYNAMIC_CONTENT_VAL;
    });
    this.personService
      .getPersonTestById(this.currentRecord.personId)
      .subscribe(response => {
        this.oldTestList = response;
        if (this.oldTestList) {
          this.oldDates = this.oldTestList.filter(obj => {
            return obj.REG_ID !== null;
          });
        }
      });
    this.appService.getUserProfile().then(user => {
      this.userProfile = user;
    });
    this.taaPin = this.currentRecord.taaPin;
    this.personId = this.currentRecord.personId;
    this.requestId = this.currentRecord.requestId;
    this.personName = this.currentRecord.personName;
    this.successMessage = false;
    this.buildForm();
  }

  ngOnDestroy() {
    for (const o of this.subscriptions) {
      o.unsubscribe();
    }
  }

  buildForm() {
    this.isLoading = true;
    this.testService
      .getTest()
      .finally(() => {
        this.isLoadingDates = false;
        this.isLoading = false;
      })
      .subscribe(response => {
        this.testOptions = response;
        this.testOptions.forEach(element => {
          if (element.TEST_NM === "ACT State and District Testing") {
            this.stateTestId = element.TEST_ID;
          }
        });
      });
    this.Name = "Test Name";
    this.frmTestingInfo = this.fb.group({
      selectedTestInformationId: ["", []]
    });
    if (this.recordCount !== "0") {
      this.frmTestingInfo.disable();
    }
  }

  public testInformationChanged(selectedTest) {
    this.errorMsg = false;
    this.showTest = false;
    this.testDateFlag = false;
    this.isLoadingDates = true;
    this.testFlag = true;
    this.testId = selectedTest.TEST_ID;
    this.displayDates = true;
    this.testDates = [];
    let getTestDates: any;
    if (this.stateTestId === this.testId) {
      getTestDates = this.testService.getStateTestDatesById(
        this.stateTestId,
        this.orgDetails["mdmId"]
      );
    } else {
      getTestDates = this.testService.getDates(this.testId);
    }
    getTestDates
      .finally(() => {
        this.isLoadingDates = false;
      })
      .subscribe(response => {
        const data: any = response.body;
        this.testDates = data;
        if (Array.isArray(data)) {
          this.testDates.forEach(element => {
            if (
              new Date(element.REQUEST_CUT_OFF_DT).toISOString() >
              new Date().toISOString()
            ) {
              element.disable = false;
            } else {
              element.disable = true;
              element.dynamicText = this.dynamicText;
            }
          });
        }
      });
  }

  updateLogs(data) {
    const loggerModel = {
      MODULE_ID: "PERSON_TEST",
      CATEGORY_ID: "PERSON_TEST_TYPE",
      COMPONENT_ID: "SELECT_TEST",
      MESSAGE_TX: "PERSON_TEST_TYPE IS NULL",
      REFERENCE_ID: this.personId,
      SEVERITY_VAL: "",
      CREATED_BY_DS: this.userProfile.loggedInUser,
      UPDATED_BY_DS: this.userProfile.loggedInUser,
      USER_DATA_VAL: data
    };
    this._loggerService.updateLog(loggerModel).subscribe(
      success => { },
      err => { console.log(err); });
  }


  public testDateSeleted(testDate) {
    this.errorMsg = false;
    this.showTestDate = false;
    this.testDateFlag = true;
    this.testDateId = testDate.TEST_DATE_ID;
    if ((testDate.TEST_DATE_TYPE === null || testDate.TEST_DATE_TYPE === undefined || testDate.TEST_DATE_TYPE === "") && testDate.TEST_DATE_TYPE !== "National") {
      this.updateLogs(JSON.stringify(testDate));
    }
    this.testDateType = testDate.TEST_DATE_TYPE;
  }
  saveTestDate(navigate) {
    this.clickOnce = true;
    for (let j = 0; j < this.testDates.length; j++) {
      if (this.testDates[j].TEST_DATE_ID === this.savedTestDate) {
        if (this.testDates[j].disable === true) {
          this.savedTestDate = null;
          this.testDates[j].TEST_DATE_ID = "";
          this.testDateFlag = false;
        }
      }
    }
    if (!this.testFlag) {
      this.clickOnce = false;
      this.errorMsg = true;
      this.showTest = true;
    } else if (this.testFlag && !this.testDateFlag) {
      this.clickOnce = false;
      this.errorMsg = true;
      this.showTestDate = true;
    } else {
      this.subscriptions.push(
        this.getResult().subscribe(response => {
          if (response) {
            this.clickOnce = false;
            if (navigate) {
              sessionStorage.setItem("testSubmitted", "true");
              this.stepper.goToNextStep();
            } else {
              this.ngOnInit();
            }
          }
        })
      );
    }
  }

  getResult() {
    const updatePersonTest: any = {
      PERSON_ID: this.personId,
      TEST_DATE_ID: this.testDateId,
      UPDATED_BY_DS: this.userProfile.userName
    };
    const personTest: any = {
      PERSON_ID: this.personId,
      TEST_DATE_ID: this.testDateId,
      CREATED_BY_DS: this.userProfile.userName,
      UPDATED_BY_DS: this.userProfile.userName
    };

    const updateRequest = {
      PERSON_ID: this.personId,
      TEST_DATE_ID: this.testDateId,
      UPDATED_BY_DS: this.userProfile.userName,
      TEST_ID: this.testId,
      REQUEST_ID: this.requestId,
      REQUEST_STATE_TX: "2"
    };
    if (this.testDateType === "State") {
      updatePersonTest.PERSON_TEST_TYPE = this.testDateType;
      personTest.PERSON_TEST_TYPE = this.testDateType;
    }
    if ((this.testDateType === null || this.testDateType === undefined || this.testDateType === "") && this.testDateType !== "National") {
      this.updateLogs("PERSON_TEST_TYPE IS" + this.testDateType);
    }
    if (this.oldTestList && this.oldTestList.length < 1) {
      return Observable.forkJoin(
        this.testService.postPersonTest(personTest),
        this.testService.updateRequest(updateRequest)
      );
    } else {
      const addTest = this.oldDates.some(
        vendor => vendor["TEST_DATE_ID"] === this.testDateId
      );
      if (addTest) {
        return Observable.forkJoin(
          this.testService.updatePersonTest(updatePersonTest),
          this.testService.updateRequest(updateRequest)
        );
      } else {
        return Observable.forkJoin(
          this.testService.deleteAndCreateTest(personTest),
          this.testService.updateRequest(updateRequest)
        );
      }
    }
  }
  goToExaminee() {
    this.stepper.goToPrevStep();
  }
  continueToNext() {
    sessionStorage.setItem("testSubmitted", "true");
    this.stepper.goToNextStep();
  }
}



// WEBPACK FOOTER //
// ./client/views/request/testinginformation/testinginformation.component.ts